import { Outlet } from 'react-router';

import { ForceLogoutWatcher } from '@/app/auth/ForceLogoutWatcher';
import { SessionExpiredWatcher } from '@/app/auth/SessionExpiredWatcher';
import { RequireAuth } from '@/app/auth/RequireAuth';
import { DebugModeProvider } from '@/ui';
import { NavLayout } from '@/app/shell/NavLayout';
import { PsapConfigurationProvider } from '@/app/shell/PsapConfigurationProvider';
import { IncidentDataProvider } from '@/app/shell/IncidentDataProvider';
import { UserInfoToConsole } from '@/app/shell/UserInfoToConsole';

export function AppShellRoute() {
  return (
    <DebugModeProvider enableShortcut>
      <RequireAuth>
        <ForceLogoutWatcher />
        <SessionExpiredWatcher />
        <PsapConfigurationProvider>
          <IncidentDataProvider>
            <NavLayout>
              <Outlet />
            </NavLayout>
            <UserInfoToConsole />
          </IncidentDataProvider>
        </PsapConfigurationProvider>
      </RequireAuth>
    </DebugModeProvider>
  );
}
